import React from 'react'

export function stripText(text){
    return text.replace('__', '')
}

export function ellipseText(length, text) {
    return text.length > length ?
        stripText(text.substring(0, length)) + "..." : stripText(text)
}

export function isWindow() {
    return typeof window !== 'undefined'
}



// WEBPACK FOOTER //
// ./src/utils/formatting.js